import { styled } from "goober";
import type { ReactNode } from "react";
import { Icon } from "./Icon";
import { Text } from "./Text";
import { Tooltip } from "./Tooltip";

const HelpIconRoot = styled("span")`
  display: inline-flex;
  align-items: center;
  opacity: 0.2;
  &:hover {
    opacity: 1;
  }
`;

export function HelpTooltip({ content }: { content: ReactNode }) {
  return (
    <Tooltip
      content={
        <div style={{ width: 200, textWrap: "pretty" }}>
          <Text variant="text-small-md">{content}</Text>
        </div>
      }
    >
      <HelpIconRoot>
        <Icon name="info" size={12} />
      </HelpIconRoot>
    </Tooltip>
  );
}
